import { Component, OnInit } from '@angular/core';
import { subDays, isAfter, isBefore } from 'date-fns';
import {
  LastSevenDaysOrdersSummaryCardComponent,
  DashboardKpiService,
  OrderStatisticsService,
  OrderStatistic
} from 'gung-dashboard';
import { first } from 'rxjs';

@Component({
    selector: 'colmec-last-seven-days-orders-summary-card',
    templateUrl: './colmec-last-seven-days-orders-summary-card.component.html',
    styleUrls: ['./colmec-last-seven-days-orders-summary-card.component.scss'],
    standalone: false
})
export class ColmecLastSevenDaysOrdersSummaryCardComponent
  extends LastSevenDaysOrdersSummaryCardComponent
  implements OnInit
{
  constructor(
    protected dashboardKpiService: DashboardKpiService,
    protected orderStatisticsService: OrderStatisticsService
  ) {
    super(dashboardKpiService, orderStatisticsService);
  }

  ngOnInit() {
    super.ngOnInit();
    // this.orderStatisticsService.getOrderStatistics()
    //   .pipe(
    //     first()
    //   ).subscribe((orderStatistics: OrderStatistic[]) => {
    //     const dateXDaysBefore = subDays(new Date(), this.numberOfDays);
    //     const dateTwoXDaysBefore = subDays(new Date(), 2 * this.numberOfDays);

    //     for (const orderStatistic of orderStatistics.filter(os => !!os.orderCreationDate)) {

    //       if (isAfter(new Date(orderStatistic.orderCreationDate), dateXDaysBefore)) { // last x days orders
    //         if (!!this.orderStatisticsLastXDays[orderStatistic.orderId]) {
    //           this.orderStatisticsLastXDays[orderStatistic.orderId] += orderStatistic.orderRowTotalValue;
    //         } else {
    //           this.orderStatisticsLastXDays[orderStatistic.orderId] = orderStatistic.orderRowTotalValue;
    //         }

    //       } else if (isAfter(new Date(orderStatistic.orderCreationDate), dateTwoXDaysBefore) // x days before the last 7 days
    //         && isBefore(new Date(orderStatistic.orderCreationDate), dateXDaysBefore)) {
    //         if (!!this.orderStatisticsXDaysBeforeLastXDays[orderStatistic.orderId]) {
    //           this.orderStatisticsXDaysBeforeLastXDays[orderStatistic.orderId] += orderStatistic.orderRowTotalValue;
    //         } else {
    //           this.orderStatisticsXDaysBeforeLastXDays[orderStatistic.orderId] = orderStatistic.orderRowTotalValue;
    //         }
    //       }
    //     }

    //     // last x days
    //     this.orderLastXDaysCount = Object.keys(this.orderStatisticsLastXDays).length;
    //     this.orderLastXDaysAvgValue = (Object.values(this.orderStatisticsLastXDays).reduce((acc, curr) => acc + curr, 0) / this.orderLastXDaysCount) || 0;

    //     // x days before the last x days
    //     this.orderXDaysBeforeLastXDaysCount = Object.keys(this.orderStatisticsXDaysBeforeLastXDays).length;

    //     this.loaded = true;
    //   });
  }
}
